import "./LocationAccountPreferencesDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";
import {CommonService} from "../../../../../shared/services";
import commonService from "../../../../../shared/services/common.service";

interface LocationAccountPreferencesDetailsViewComponentProps {
    locationAccountPreferences: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LocationAccountPreferencesDetailsViewComponent = (props: LocationAccountPreferencesDetailsViewComponentProps) => {
    const {locationAccountPreferences, onEditModeOpen, canEdit} = props;

    return (
        <div className={'account-preferences-details-view-component details-tab-data-content'}>
            <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Preferred Delivery Report</div>
                    {canEdit &&<div className={'edit-action-button'}>
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={onEditModeOpen}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <DetailsDataKeyValueComponent
                        title={"Method"}> {locationAccountPreferences?.preferredReportDelivery || 'NA'} </DetailsDataKeyValueComponent>
                    {locationAccountPreferences?.preferredReportDelivery === 'auto-fax' &&
                        <DetailsDataKeyValueComponent
                            title={"Fax Number"}> {commonService.getMaskedMobileNumber( locationAccountPreferences?.preferredReportDeliveryValue) || 'NA'} </DetailsDataKeyValueComponent>}
                    {locationAccountPreferences?.preferredReportDelivery === 'email' &&
                        <DetailsDataKeyValueComponent
                            title={"Email ID"}> {locationAccountPreferences?.preferredReportDeliveryValue || 'NA'} </DetailsDataKeyValueComponent>}
                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Specimen Pickup Delivery Method</div>
                    <DetailsDataKeyValueComponent
                        title={"Method"}> {locationAccountPreferences?.preferredDeliveryMethod || 'NA'} </DetailsDataKeyValueComponent>
                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Specimen Pickup Schedule</div>
                    <DetailsDataKeyValueComponent
                        title={"Method"}> {locationAccountPreferences?.specimenPickUpScheduleType || 'NA'} </DetailsDataKeyValueComponent>

                    {locationAccountPreferences?.specimenPickUpScheduleType === 'recurring' ? <>
                        <div className={'display-flex-with-column-gap mrg-top-20'}>
                            {locationAccountPreferences?.specimenPickUpSchedule && locationAccountPreferences.specimenPickUpSchedule.map((dayAndTime: any, index: any) => {
                                    return (
                                        <div key={index}>
                                            <ChipComponent
                                                label={`${CommonService.capitalizeFirstLetter(dayAndTime.day)} | ${dayAndTime.time}`}
                                            />
                                        </div>
                                    )
                                }
                            )
                            }
                        </div>
                    </> : <>
                        <FeedbackComponent className={'width-50 mrg-top-5'}>
                            Call Lab whenever the specimen pickup is ready.
                        </FeedbackComponent>
                    </>
                    }

                </div>
            </>
        </div>
    );

};

export default LocationAccountPreferencesDetailsViewComponent;
